module.exports = __webpack_public_path__ + "static/img/guy-img.6bd4134.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/guy-img.png
// module id = 1393
// module chunks = 1